export const SettingTypes =  {
  custom: 'custom',
  input: 'input',
  boolean: 'boolean',
  radio_button: 'radio-button',
  color_picker: 'color-picker',
  switch: 'switch',
  slider: 'slider',
  select: 'select',
  date_picker: 'date-picker'
}

export default SettingTypes
